declare var jQuery: any;

import { EventEmitter, Injectable } from '@angular/core'
import '@burt-ui/semantic/definitions/modules/modal.js'

@Injectable()
export class ModalService {
  onRegister = new EventEmitter()
  onOpen = new EventEmitter()
  onOpened = new EventEmitter()
  onClose = new EventEmitter()
  onHidden = new EventEmitter()

  open(component, options = {}) {
    this.onOpen.emit({component: component, options: options})
  }

  close() {
    this.onClose.emit()
  }
}
